// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".needsAttentionMarker{position:relative;top:-2px;display:inline-block;border-radius:50%;background:red;width:7px;height:7px}#chat-dock{z-index:3;position:fixed;bottom:0;right:1em}", ""]);
// Exports
module.exports = exports;
